// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unit-page-layout header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.unit-page-layout header .header__side.right {
  display: inline-flex;
  align-items: center;
  gap: 180px;
}
.unit-page-layout header .header__side.right .shift-actions-block {
  gap: 16px;
}
.unit-page-layout header .header__facility {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--Secondary-On-Surface, #98a2b3);
}
.unit-page-layout header .header__back-link {
  display: inline-flex;
  margin-top: 10px;
  gap: 16px;
  font-size: 25px;
  font-weight: 700;
  line-height: 38px;
  align-items: center;
  text-decoration: none;
}
.unit-page-layout header .header__back-link:any-link {
  color: var(--Secondary-eading, #101828);
}
.unit-page-layout header .header__shifts {
  display: inline-flex;
  gap: 16px;
  align-items: center;
}
.unit-page-layout header .header__shifts .pagination-btn {
  display: inline-flex;
  font-size: 14px;
  align-items: center;
  gap: 12px;
}
.unit-page-layout header .header__shifts__item {
  min-width: 170px;
  display: inline-flex;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  position: relative;
}
.unit-page-layout header .header__shifts__item.archive {
  color: var(--Secondary-On-Surface, #98a2b3);
}
.unit-page-layout header .header__shifts__item .name {
  display: inline-block;
  margin-left: 4px;
  text-transform: uppercase;
}
.unit-page-layout header .header__shifts__item:not(.archive) .date {
  color: var(--Primary-600, #7f56d9);
}
.unit-page-layout header .header__shifts__item:not(.archive) .name {
  color: var(--Secondary-eading, #101828);
}
.unit-page-layout header .header__shifts__item .archive-shift-label {
  top: 100%;
  right: 0;
  position: absolute;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--Primary-600, #7f56d9);
}
.unit-page-layout .staff {
  display: flex;
  margin-top: 24px;
  gap: 16px;
  justify-content: space-between;
}
.unit-page-layout .staff__block {
  flex: 1 1;
}
.unit-page-layout .staff__block:first-child {
  width: 100%;
  max-width: 320px;
}
.unit-page-layout .staff__block:last-child {
  max-width: 63%;
}
.unit-page-layout .staff__block__title {
  min-height: 20px;
  display: inline-flex;
  gap: 16px;
  align-items: center;
  color: var(--Secondary-Text, #667085);
}
.unit-page-layout .staff__block__content {
  margin-top: 4px;
}
.unit-page-layout .staff__nurses {
  display: flex;
  gap: 4px 12px;
  flex-wrap: wrap;
}
.unit-page-layout .staff__nurses__item {
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
}
.unit-page-layout .staff__cna-list {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}
.unit-page-layout .staff__cna-item {
  height: 44px;
  display: inline-flex;
  padding-right: 4px;
  border-radius: 8px;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  border: 1px dashed transparent;
}
.unit-page-layout .staff__cna-item .cna-name {
  height: 100%;
  display: inline-flex;
  padding-left: 10px;
  align-items: center;
  cursor: pointer;
}
.unit-page-layout .staff__cna-item .cna-menu-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.unit-page-layout .table-container {
  max-height: initial;
  margin-top: 24px;
  overflow: initial;
}
.unit-page-layout .table-container thead {
  border-bottom: none;
}
.unit-page-layout .table-container thead th {
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
}
.unit-page-layout .table-container thead th.cna {
  min-width: 150px;
  cursor: pointer;
}
.unit-page-layout .table-container thead th.cna:hover {
  opacity: 0.7;
}
.unit-page-layout .table-container thead th.room {
  min-width: 62px;
  cursor: pointer;
}
.unit-page-layout .table-container thead th.room:hover {
  opacity: 0.7;
}
.unit-page-layout .table-container thead th.resident {
  min-width: 180px;
}
.unit-page-layout .table-container thead th.tasks {
  width: 100%;
}
.unit-page-layout .table-container tbody tr {
  z-index: 1;
}
.unit-page-layout .table-container tbody tr:not(.has-cna):not(.prev-row-selected) {
  border-top: 1px solid #cbd2e0;
}
.unit-page-layout .table-container tbody tr.next-row-selected {
  border-bottom: unset !important;
}
.unit-page-layout .table-container tbody tr.prev-row-selected {
  border-top: unset !important;
}
.unit-page-layout .table-container tbody tr.selected {
  border: 2px dashed black !important;
  outline: none !important;
}
.unit-page-layout .table-container tbody tr td {
  width: initial;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  padding: 2px 24px;
}
.unit-page-layout .table-container tbody tr td.cna-column {
  border-right: 1px solid #cbd2e0;
}
.unit-page-layout .table-container tbody tr td .room-col {
  gap: 6px;
}
.unit-page-layout .table-container tbody tr td .tasks {
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
}
@media print {
  .unit-page-layout .table-container tbody tr td .tasks__empty-list {
    color: transparent;
  }
}
.unit-page-layout .table-container tbody tr td .tasks__list {
  width: 100%;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item:not(:last-child) {
  border-bottom: 1px dashed #cbd2e0;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item:not(:only-child) {
  padding-bottom: 4px;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item:nth-child(n+2) {
  padding-top: 4px;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .inner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .inner .context-menu-btn {
  height: fit-content;
  min-width: unset;
  width: fit-content;
  padding: 3px 5px !important;
  margin-top: 0px;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-name {
  width: 100%;
  display: flex;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-name span {
  line-height: 20px;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-name.as-new-comment-btn {
  cursor: pointer;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-name.as-new-comment-btn:hover {
  color: #7f56d9;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-name .task-name-block {
  line-height: 20px;
  width: 100%;
  width: -moz-fill-available;
  width: -webkit-fill-available;
  width: fill-available;
  max-width: max-content;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments {
  width: 100%;
  width: -moz-fill-availble;
  width: -webkit-fill-available;
  width: fill-available;
  min-width: min-content;
  display: flex;
  gap: 4px;
  margin-left: 15px;
  font-size: 14px;
  line-height: 20px;
  color: rgb(102, 112, 133);
  justify-content: space-between;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__list {
  width: 100%;
  margin-left: 12px;
  padding-left: 10px;
  list-style-type: decimal;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__list .comment:nth-child(n+2) {
  margin-top: 10px;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__list .comment:hover .comment__actions, .unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__list .comment:focus .comment__actions {
  visibility: visible;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__list .comment__inner {
  display: flex;
  gap: 16px;
  justify-content: space-between;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__list .comment__body {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  min-width: 70px;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__list .comment__actions {
  min-width: 48px;
  display: inline-flex;
  gap: 16px;
  visibility: hidden;
  align-items: center;
  margin-right: 10px;
}
.unit-page-layout .table-container tbody tr td .tasks__list__item .task-comments__count-btn {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #98a2b3;
  outline: none;
  border: 0;
  background-color: transparent;
}
.unit-page-layout .table-container tbody tr td .tasks__actions {
  margin-left: 24px;
}
.unit-page-layout .table-container tbody tr td .tasks__actions .add-task-btn {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 3px 8px !important;
  height: fit-content;
  margin-top: 2px;
  margin-bottom: 2px;
}

.tablet .unit-page-layout .page-wrapper {
  padding: 0 24px 32px 24px;
}
.tablet .unit-page-layout .page-wrapper .header__facility {
  display: inline-flex;
  align-items: center;
}
.tablet .unit-page-layout .page-wrapper .header__facility span {
  margin-left: 16px;
}
.tablet .unit-page-layout .page-wrapper .header__side.left {
  display: flex;
  flex-direction: row-reverse;
}
.tablet .unit-page-layout .page-wrapper .header__side.left .header__back-link {
  font-size: 16px;
  white-space: nowrap;
  margin-top: 0;
}
.tablet .unit-page-layout .page-wrapper .header__side.right .header__shifts .btn {
  background: transparent !important;
  border: none !important;
  transition: none !important;
  box-shadow: none !important;
  gap: 10px !important;
}
.tablet .unit-page-layout .page-wrapper .header__side.right .header__shifts .btn.disabled {
  opacity: 0.5;
}
.tablet .unit-page-layout .page-wrapper .staff {
  display: inline;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__flex {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__block__title {
  align-items: flex-start;
  font-size: 14px;
  width: 83px !important;
  justify-content: space-between;
  line-height: 20px;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__block__content {
  padding-right: 24px;
  margin-top: 0px;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__block__content .staff__nurses {
  justify-content: flex-start;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__block__content .staff__nurses .staff__nurses__item {
  line-height: 20px;
  font-size: 12px;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__block__content .nurses_title {
  line-height: 20px;
}
.tablet .unit-page-layout .page-wrapper .staff .left-block .staff__nurses__block {
  display: flex;
  gap: 16px;
}
.tablet .unit-page-layout .page-wrapper .staff .left-block .staff__nurses__block .staff__nurses {
  gap: 4px 20px;
}
.tablet .unit-page-layout .page-wrapper .staff .right-block {
  display: flex;
  gap: 16px;
}
.tablet .unit-page-layout .page-wrapper .staff .right-block .btn {
  width: 56px !important;
  height: 44px !important;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__cna__block {
  margin-top: 10px;
  display: inline;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__cna__block .staff__block {
  width: 100% !important;
  max-width: unset !important;
  display: inline;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__cna__block .staff__block .staff__block__content {
  padding-right: 0px;
  margin-top: 8px;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__cna__block .staff__block .staff__block__content.staff__block_cna {
  position: sticky;
  top: 80px;
  z-index: 4;
  background-color: #fff;
  padding-top: 8px;
  padding-bottom: 8px;
}
.tablet .unit-page-layout .page-wrapper .staff .staff__cna__block .staff__block .staff__block__content .staff__cna-list .staff__cna-item .cna-name {
  font-size: 12px;
  line-height: 20px;
}
.tablet .unit-page-layout .page-wrapper .table-container {
  font-size: 14px !important;
}
.tablet .unit-page-layout .page-wrapper .table-container th.cna,
.tablet .unit-page-layout .page-wrapper .table-container td.cna-column {
  max-width: 95px;
  min-width: unset;
  padding-left: 12px;
  padding-right: 12px;
}
.tablet .unit-page-layout .page-wrapper .table-container th.room,
.tablet .unit-page-layout .page-wrapper .table-container td.room-column {
  max-width: 75px;
  padding-left: 4px;
  padding-right: 4px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.room-column {
  word-break: break-word;
}
.tablet .unit-page-layout .page-wrapper .table-container th.resident,
.tablet .unit-page-layout .page-wrapper .table-container td.resident-column {
  max-width: 95px;
  min-width: unset;
  padding-left: 12px;
  padding-right: 12px;
}
.tablet .unit-page-layout .page-wrapper .table-container th.tasks {
  padding-left: 24px;
  padding-right: 24px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.tasks-column {
  padding-left: 10px;
  padding-right: 0px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.tasks-column .tasks {
  gap: 10px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.tasks-column .tasks .context-menu-btn svg {
  height: 14px;
  width: 14px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.tasks-column .tasks .tasks__actions {
  margin-left: 0px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.tasks-column .tasks .tasks__actions .add-task-btn {
  margin: 5px 16px;
  padding: 15px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.tasks-column .tasks .tasks__actions .add-task-btn svg {
  height: 14px;
  width: 14px;
}
.tablet .unit-page-layout .page-wrapper .table-container td.tasks-column .tasks .comment__actions {
  visibility: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/cna/assignments/unit/styles.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AAIQ;EACE,oBAAA;EACA,mBAAA;EACA,UAAA;AAFV;AAIU;EACE,SAAA;AAFZ;AAOM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;AALR;AAQM;EACE,oBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AANR;AAQQ;EACE,uCAAA;AANV;AAUM;EACE,oBAAA;EACA,SAAA;EACA,mBAAA;AARR;AAUQ;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AARV;AAWQ;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AATV;AAWU;EACE,2CAAA;AATZ;AAYU;EACE,qBAAA;EACA,gBAAA;EACA,yBAAA;AAVZ;AAcY;EACE,kCAAA;AAZd;AAeY;EACE,uCAAA;AAbd;AAiBU;EACE,SAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;AAfZ;AAsBE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,8BAAA;AApBJ;AAsBI;EACE,SAAA;AApBN;AAsBM;EACE,WAAA;EACA,gBAAA;AApBR;AAuBM;EACE,cAAA;AArBR;AAwBM;EACE,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;AAtBR;AAyBM;EACE,eAAA;AAvBR;AA2BI;EACE,aAAA;EACA,aAAA;EACA,eAAA;AAzBN;AA2BM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAzBR;AA6BI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA3BN;AA8BI;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8BAAA;AA5BN;AA8BM;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AA5BR;AA+BM;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA7BR;AAmCI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAjCN;AAmCM;EACE,mBAAA;AAjCR;AAmCQ;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AAjCV;AAmCU;EACE,gBAAA;EACA,eAAA;AAjCZ;AAmCY;EACE,YAAA;AAjCd;AAqCU;EACE,eAAA;EACA,eAAA;AAnCZ;AAqCY;EACE,YAAA;AAnCd;AAuCU;EACE,gBAAA;AArCZ;AAwCU;EACE,WAAA;AAtCZ;AA4CQ;EAeE,UAAA;AAxDV;AA2CY;EACE,6BAAA;AAzCd;AA6CU;EACE,+BAAA;AA3CZ;AA8CU;EACE,4BAAA;AA5CZ;AAiDU;EACE,mCAAA;EACA,wBAAA;AA/CZ;AAkDU;EACE,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAhDZ;AAiDY;EACE,+BAAA;AA/Cd;AAkDY;EACE,QAAA;AAhDd;AAmDY;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AAjDd;AAoDgB;EADF;IAEI,kBAAA;EAjDhB;AACF;AAoDc;EACE,WAAA;AAlDhB;AAqDkB;EACE,iCAAA;AAnDpB;AAsDkB;EACE,mBAAA;AApDpB;AAuDkB;EACE,gBAAA;AArDpB;AAwDkB;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAtDpB;AAuDoB;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;AArDtB;AAyDkB;EACE,WAAA;EAEA,aAAA;AAxDpB;AA0DoB;EACE,iBAAA;AAxDtB;AA0DoB;EACE,eAAA;AAxDtB;AA0DsB;EACE,cAAA;AAxDxB;AA4DoB;EACE,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;AA1DtB;AA8DkB;EACE,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;AA5DpB;AA8DoB;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AA5DtB;AA+DwB;EACE,gBAAA;AA7D1B;AAkE0B;EACE,mBAAA;AAhE5B;AAoEwB;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AAlE1B;AAqEwB;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAnE1B;AAsEwB;EACE,eAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AApE1B;AAyEoB;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,6BAAA;AAvEtB;AA6Ec;EACE,iBAAA;AA3EhB;AA6EgB;EACE,oBAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AA3ElB;;AAwFI;EACE,yBAAA;AArFN;AAuFM;EACE,oBAAA;EACA,mBAAA;AArFR;AAuFQ;EACE,iBAAA;AArFV;AAyFM;EACE,aAAA;EACA,2BAAA;AAvFR;AAyFQ;EACE,eAAA;EACA,mBAAA;EACA,aAAA;AAvFV;AA6FU;EACE,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EAMA,oBAAA;AAhGZ;AA4FY;EACE,YAAA;AA1Fd;AAkGM;EACE,eAAA;AAhGR;AAkGQ;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AAhGV;AAmGQ;EACE,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AAjGV;AAoGQ;EACE,mBAAA;EACA,eAAA;AAlGV;AAmGU;EACE,2BAAA;AAjGZ;AAmGY;EACE,iBAAA;EACA,eAAA;AAjGd;AAqGU;EACE,iBAAA;AAnGZ;AAwGU;EACE,aAAA;EACA,SAAA;AAtGZ;AAwGY;EACE,aAAA;AAtGd;AA2GQ;EACE,aAAA;EACA,SAAA;AAzGV;AA2GU;EACE,sBAAA;EACA,uBAAA;AAzGZ;AA6GQ;EACE,gBAAA;EACA,eAAA;AA3GV;AA4GU;EACE,sBAAA;EACA,2BAAA;EACA,eAAA;AA1GZ;AA2GY;EACE,kBAAA;EACA,eAAA;AAzGd;AA2Gc;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAzGhB;AA8GkB;EACE,eAAA;EACA,iBAAA;AA5GpB;AAqHM;EACE,0BAAA;AAnHR;AAqHQ;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAnHV;AAsHQ;;EAEE,eAAA;EACA,iBAAA;EACA,kBAAA;AApHV;AAuHQ;EACE,sBAAA;AArHV;AAwHQ;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAtHV;AAyHQ;EACE,kBAAA;EACA,mBAAA;AAvHV;AA0HQ;EACE,kBAAA;EACA,kBAAA;AAxHV;AA0HU;EACE,SAAA;AAxHZ;AA2Hc;EACE,YAAA;EACA,WAAA;AAzHhB;AA6HY;EACE,gBAAA;AA3Hd;AA6Hc;EACE,gBAAA;EACA,aAAA;AA3HhB;AA4HgB;EACE,YAAA;EACA,WAAA;AA1HlB;AA+HY;EACE,8BAAA;AA7Hd","sourcesContent":[".unit-page-layout {\n  header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .header {\n      &__side {\n        &.right {\n          display: inline-flex;\n          align-items: center;\n          gap: 180px;\n\n          .shift-actions-block {\n            gap: 16px;\n          }\n        }\n      }\n\n      &__facility {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        color: var(--Secondary-On-Surface, #98a2b3);\n      }\n\n      &__back-link {\n        display: inline-flex;\n        margin-top: 10px;\n        gap: 16px;\n        font-size: 25px;\n        font-weight: 700;\n        line-height: 38px;\n        align-items: center;\n        text-decoration: none;\n\n        &:any-link {\n          color: var(--Secondary-eading, #101828);\n        }\n      }\n\n      &__shifts {\n        display: inline-flex;\n        gap: 16px;\n        align-items: center;\n\n        .pagination-btn {\n          display: inline-flex;\n          font-size: 14px;\n          align-items: center;\n          gap: 12px;\n        }\n\n        &__item {\n          min-width: 170px;\n          display: inline-flex;\n          font-size: 16px;\n          font-weight: 600;\n          line-height: 24px;\n          position: relative;\n\n          &.archive {\n            color: var(--Secondary-On-Surface, #98a2b3);\n          }\n\n          .name {\n            display: inline-block;\n            margin-left: 4px;\n            text-transform: uppercase;\n          }\n\n          &:not(.archive) {\n            .date {\n              color: var(--Primary-600, #7f56d9);\n            }\n\n            .name {\n              color: var(--Secondary-eading, #101828);\n            }\n          }\n\n          .archive-shift-label {\n            top: 100%;\n            right: 0;\n            position: absolute;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            color: var(--Primary-600, #7f56d9);\n          }\n        }\n      }\n    }\n  }\n\n  .staff {\n    display: flex;\n    margin-top: 24px;\n    gap: 16px;\n    justify-content: space-between;\n\n    &__block {\n      flex: 1;\n\n      &:first-child {\n        width: 100%;\n        max-width: 320px; // 36%\n      }\n\n      &:last-child {\n        max-width: 63%;\n      }\n\n      &__title {\n        min-height: 20px;\n        display: inline-flex;\n        gap: 16px;\n        align-items: center;\n        color: var(--Secondary-Text, #667085);\n      }\n\n      &__content {\n        margin-top: 4px;\n      }\n    }\n\n    &__nurses {\n      display: flex;\n      gap: 4px 12px;\n      flex-wrap: wrap;\n\n      &__item {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 28px;\n      }\n    }\n\n    &__cna-list {\n      display: flex;\n      gap: 12px;\n      flex-wrap: wrap;\n      align-items: center;\n    }\n\n    &__cna-item {\n      height: 44px;\n      display: inline-flex;\n      padding-right: 4px;\n      border-radius: 8px;\n      align-items: center;\n      user-select: none;\n      border: 1px dashed transparent;\n\n      .cna-name {\n        height: 100%;\n        display: inline-flex;\n        padding-left: 10px;\n        align-items: center;\n        cursor: pointer;\n      }\n\n      .cna-menu-btn {\n        width: 32px;\n        height: 32px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n      }\n    }\n  }\n\n  .table {\n    &-container {\n      max-height: initial;\n      margin-top: 24px;\n      overflow: initial;\n\n      thead {\n        border-bottom: none;\n\n        th {\n          font-size: 16px;\n          text-align: center;\n          white-space: nowrap;\n\n          &.cna {\n            min-width: 150px;\n            cursor: pointer;\n\n            &:hover {\n              opacity: 0.7;\n            }\n          }\n\n          &.room {\n            min-width: 62px;\n            cursor: pointer;\n\n            &:hover {\n              opacity: 0.7;\n            }\n          }\n\n          &.resident {\n            min-width: 180px;\n          }\n\n          &.tasks {\n            width: 100%;\n          }\n        }\n      }\n\n      tbody {\n        tr {\n          &:not(.has-cna) {\n            &:not(.prev-row-selected) {\n              border-top: 1px solid #cbd2e0;\n            }\n          }\n\n          &.next-row-selected {\n            border-bottom: unset !important;\n          }\n\n          &.prev-row-selected {\n            border-top: unset !important;\n          }\n\n          z-index: 1;\n\n          &.selected {\n            border: 2px dashed black !important;\n            outline: none !important;\n          }\n\n          td {\n            width: initial;\n            user-select: none;\n            vertical-align: middle;\n            padding: 2px 24px;\n            &.cna-column {\n              border-right: 1px solid #cbd2e0;\n            }\n\n            .room-col {\n              gap: 6px;\n            }\n\n            .tasks {\n              display: flex;\n              gap: 24px;\n              align-items: center;\n              justify-content: space-between;\n\n              &__empty-list {\n                @media print {\n                  color: transparent;\n                }\n              }\n\n              &__list {\n                width: 100%;\n\n                &__item {\n                  &:not(:last-child) {\n                    border-bottom: 1px dashed #cbd2e0;\n                  }\n\n                  &:not(:only-child) {\n                    padding-bottom: 4px;\n                  }\n\n                  &:nth-child(n + 2) {\n                    padding-top: 4px;\n                  }\n\n                  .inner {\n                    width: 100%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n                    .context-menu-btn {\n                      height: fit-content;\n                      min-width: unset;\n                      width: fit-content;\n                      padding: 3px 5px !important;\n                      margin-top: 0px;\n                    }\n                  }\n\n                  .task-name {\n                    width: 100%;\n\n                    display: flex;\n\n                    span {\n                      line-height: 20px;\n                    }\n                    &.as-new-comment-btn {\n                      cursor: pointer;\n\n                      &:hover {\n                        color: #7f56d9;\n                      }\n                    }\n\n                    .task-name-block {\n                      line-height: 20px;\n                      width: 100%;\n                      width: -moz-fill-available;\n                      width: -webkit-fill-available;\n                      width: fill-available;\n                      max-width: max-content;\n                    }\n                  }\n\n                  .task-comments {\n                    width: 100%;\n                    width: -moz-fill-availble;\n                    width: -webkit-fill-available;\n                    width: fill-available;\n                    min-width: min-content;\n                    display: flex;\n                    gap: 4px;\n                    margin-left: 15px;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: rgba(102, 112, 133, 1);\n                    justify-content: space-between;\n\n                    &__list {\n                      width: 100%;\n                      margin-left: 12px;\n                      padding-left: 10px;\n                      list-style-type: decimal;\n\n                      .comment {\n                        &:nth-child(n + 2) {\n                          margin-top: 10px;\n                        }\n\n                        &:hover,\n                        &:focus {\n                          .comment__actions {\n                            visibility: visible;\n                          }\n                        }\n\n                        &__inner {\n                          display: flex;\n                          gap: 16px;\n                          justify-content: space-between;\n                        }\n\n                        &__body {\n                          font-size: 14px;\n                          font-weight: 400;\n                          line-height: 20px;\n                          min-width: 70px;\n                        }\n\n                        &__actions {\n                          min-width: 48px;\n                          display: inline-flex;\n                          gap: 16px;\n                          visibility: hidden;\n                          align-items: center;\n                          margin-right: 10px;\n                        }\n                      }\n                    }\n\n                    &__count-btn {\n                      font-size: 14px;\n                      font-weight: 400;\n                      line-height: 20px;\n                      color: #98a2b3;\n                      outline: none;\n                      border: 0;\n                      background-color: transparent;\n                    }\n                  }\n                }\n              }\n\n              &__actions {\n                margin-left: 24px;\n\n                .add-task-btn {\n                  display: inline-flex;\n                  gap: 8px;\n                  align-items: center;\n                  padding: 3px 8px !important;\n                  height: fit-content;\n                  margin-top: 2px;\n                  margin-bottom: 2px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.tablet {\n  .unit-page-layout {\n    .page-wrapper {\n      padding: 0 24px 32px 24px;\n\n      .header__facility {\n        display: inline-flex;\n        align-items: center;\n\n        span {\n          margin-left: 16px;\n        }\n      }\n\n      .header__side.left {\n        display: flex;\n        flex-direction: row-reverse;\n\n        .header__back-link {\n          font-size: 16px;\n          white-space: nowrap;\n          margin-top: 0;\n        }\n      }\n\n      .header__side.right {\n        .header__shifts {\n          .btn {\n            background: transparent !important;\n            border: none !important;\n            transition: none !important;\n            box-shadow: none !important;\n\n            &.disabled {\n              opacity: 0.5;\n            }\n\n            gap: 10px !important;\n          }\n        }\n      }\n\n      .staff {\n        display: inline;\n\n        .staff__flex {\n          margin-top: 24px;\n          display: flex;\n          justify-content: space-between;\n        }\n\n        .staff__block__title {\n          align-items: flex-start;\n          font-size: 14px;\n          width: 83px !important;\n          justify-content: space-between;\n          line-height: 20px;\n        }\n\n        .staff__block__content {\n          padding-right: 24px;\n          margin-top: 0px;\n          .staff__nurses {\n            justify-content: flex-start;\n\n            .staff__nurses__item {\n              line-height: 20px;\n              font-size: 12px;\n            }\n          }\n\n          .nurses_title {\n            line-height: 20px;\n          }\n        }\n\n        .left-block {\n          .staff__nurses__block {\n            display: flex;\n            gap: 16px;\n\n            .staff__nurses {\n              gap: 4px 20px;\n            }\n          }\n        }\n\n        .right-block {\n          display: flex;\n          gap: 16px;\n\n          .btn {\n            width: 56px !important;\n            height: 44px !important;\n          }\n        }\n\n        .staff__cna__block {\n          margin-top: 10px;\n          display: inline;\n          .staff__block {\n            width: 100% !important;\n            max-width: unset !important;\n            display: inline;\n            .staff__block__content {\n              padding-right: 0px;\n              margin-top: 8px;\n\n              &.staff__block_cna {\n                position: sticky;\n                top: 80px;\n                z-index: 4;\n                background-color: #fff;\n                padding-top: 8px;\n                padding-bottom: 8px;\n              }\n\n              .staff__cna-list {\n                .staff__cna-item {\n                  .cna-name {\n                    font-size: 12px;\n                    line-height: 20px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .table-container {\n        font-size: 14px !important;\n\n        th.cna,\n        td.cna-column {\n          max-width: 95px;\n          min-width: unset;\n          padding-left: 12px;\n          padding-right: 12px;\n        }\n\n        th.room,\n        td.room-column {\n          max-width: 75px;\n          padding-left: 4px;\n          padding-right: 4px;\n        }\n\n        td.room-column {\n          word-break: break-word;\n        }\n\n        th.resident,\n        td.resident-column {\n          max-width: 95px;\n          min-width: unset;\n          padding-left: 12px;\n          padding-right: 12px;\n        }\n\n        th.tasks {\n          padding-left: 24px;\n          padding-right: 24px;\n        }\n\n        td.tasks-column {\n          padding-left: 10px;\n          padding-right: 0px;\n\n          .tasks {\n            gap: 10px;\n\n            .context-menu-btn {\n              svg {\n                height: 14px;\n                width: 14px;\n              }\n            }\n\n            .tasks__actions {\n              margin-left: 0px;\n\n              .add-task-btn {\n                margin: 5px 16px;\n                padding: 15px;\n                svg {\n                  height: 14px;\n                  width: 14px;\n                }\n              }\n            }\n\n            .comment__actions {\n              visibility: visible !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
